import { render, staticRenderFns } from "./forwardingReport.vue?vue&type=template&id=dfc62588&scoped=true&"
import script from "./forwardingReport.vue?vue&type=script&lang=js&"
export * from "./forwardingReport.vue?vue&type=script&lang=js&"
import style0 from "./forwardingReport.vue?vue&type=style&index=0&id=dfc62588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc62588",
  null
  
)

export default component.exports